export default __webpack_public_path__ + "static/media/castlepeak-crop.831d4e8b.jpg";